import { useState, useEffect } from 'react';
import userService from '../services/userService';

/**
 * Хук для проверки прав администратора
 */
export const useAdmin = (telegramId: string | null) => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!telegramId) {
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const adminStatus = await userService.checkIsAdmin(telegramId);
        setIsAdmin(adminStatus);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdmin();
  }, [telegramId]);

  return {
    isAdmin,
    isLoading,
  };
};

